import { css } from '@emotion/react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import { NvSampleEmail } from 'shared/components/nv-sample-email';
import SamplePushNotification from 'communications/course_communications/components/communication-modal/sample_push_notification/sample-push-notification';
import { getCurrentCourse } from 'redux/selectors/course';
import { gray4 } from 'styles/global_defaults/colors';
import { sanitize, SanitizationLevel } from 'froala/helpers/sanitizer';
import { ContactLearnersFormValues } from './contact-learners-form';

const FROM_ADDRESS = '"LXD" <noreply-novoed@novoed.com>';

const styles = css`
  .email-section-header {
    border-top: 2px solid ${gray4};
    border-bottom: 1px solid ${gray4};
  }
`;

/**
 * Step 2 body — read-only preview of the composed message.
 * Reads values from the shared RHF FormProvider via useWatch.
 */
const StepPreview = () => {
  const { control } = useFormContext<ContactLearnersFormValues>();
  const currentCourse = useSelector(getCurrentCourse);
  const [subject, body, includePushNotification, pushNotificationBody] = useWatch({
    control,
    name: ['subject', 'body', 'includePushNotification', 'pushNotificationBody'],
  });

  return (
    <div css={styles}>
      <div className='email-section-header d-flex align-items-center font-weight-bolder py-4 mt-4 mb-4'>
        <span>{t.LEARNER_PROGRESS.CONTACT_BAR.MODAL.EMAIL_SECTION()}</span>
      </div>
      <NvSampleEmail
        subject={subject}
        from={FROM_ADDRESS}
        content={body}
      />
      {includePushNotification && (
        <div>
          <SamplePushNotification
            notification={{
              title: sanitize(currentCourse?.name ?? '', SanitizationLevel.NO_TAGS),
              bodyText: sanitize(pushNotificationBody, SanitizationLevel.NO_TAGS),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default StepPreview;
